module.exports = __webpack_public_path__ + "img/dp-pricing.d975aa95.svg";